import { render, staticRenderFns } from "./B2CServicesListDetails.vue?vue&type=template&id=c7e2d35a&scoped=true&"
import script from "./B2CServicesListDetails.vue?vue&type=script&lang=js&"
export * from "./B2CServicesListDetails.vue?vue&type=script&lang=js&"
import style0 from "./B2CServicesListDetails.vue?vue&type=style&index=0&id=c7e2d35a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e2d35a",
  null
  
)

export default component.exports